import { render, staticRenderFns } from "./send_verification_code_button.vue?vue&type=template&id=1ba1b062&"
import script from "./send_verification_code_button.vue?vue&type=script&lang=js&"
export * from "./send_verification_code_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports